import isPlainObject from 'lodash/isObject';
import isString from 'lodash/isString';
import has from 'lodash/has';
import get from 'lodash/get';
import set from 'lodash/set';
const knownMingoCalculations = [
    'insurance.pricing.quote.expression',
    'insurance.forms.calculateData',
    'insurance.cancellation.calculate',
    'insurance.forms.calculateForms',
];
const convertCalculationsToObjects = (ion) => {
    // run through the known paths
    knownMingoCalculations.forEach((path) => {
        if (has(ion, path)) {
            const value = get(ion, path);
            if (isString(value)) {
                set(ion, path, JSON.parse(value));
            }
        }
    });
    // recursively look for _calculate
    const parseCalculations = (obj) => {
        if (Array.isArray(obj) || isPlainObject(obj)) {
            Object.entries(obj).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    Object.assign(obj, { [key]: value.map(parseCalculations) });
                }
                else if (isPlainObject(value)) {
                    Object.assign(obj, { [key]: parseCalculations(value) });
                }
            });
        }
        if (isPlainObject(obj) && isString(obj?._calculate)) {
            Object.assign(obj, { _calculate: JSON.parse(obj._calculate) });
        }
        return obj;
    };
    return parseCalculations(ion);
};
export default convertCalculationsToObjects;
